import { Alert, Snackbar } from '@mui/material';

export type DownloadStatus = 'Downloading' | 'Finished';

interface Props {
    status: DownloadStatus | null;
    onClose?: () => void;
}

export default function DownloadNotifier(props: Props) {
    const { status, onClose } = props;

    const open = status !== null;
    const isDownloading = status === 'Downloading';
    const severity = isDownloading ? 'info' : 'success';

    const progressMessage = 'Downloading maps for offline use...';
    const finishedMessage = 'Finished downloading for offline use!';
    const message = isDownloading ? progressMessage : finishedMessage;

    return (
        <Snackbar open={open} sx={{ bottom: '80px !important', top: 'auto' }}>
            <Alert severity={severity} variant="filled" sx={{ width: '100%' }} onClose={onClose}>
                {message}
            </Alert>
        </Snackbar>
    );
}
